import { css } from 'styled-components'

export const clearList = css`
  list-style: none;
  padding: 0;
  margin: 0;
`
export const responseWidth = css `
  width: 100%;
`
export const elipsis = css `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 100%;
  width: auto;
`
export const multiElipsis = css`
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 16px;
`
export const thirdElipsis = css`
  display: -webkit-box !important;
  -webkit-line-clamp: 3 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  white-space: pre-wrap !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;
  line-height: 16px;
`
export const dropBase = css`
  background-color: var(--ter-clr-bg);
  border: 1px solid var(--sec-clr-ln);
  box-shadow: var(--sec-shd-bx);
  border-radius: var(--sec-rd);
`
export const headTable = css`
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
`
export const formLabel = css`
  color: var(--hd-clr);
  font-weight: 600;
  font-size: 13px;
  text-transform: capitalize;
`

export const buttonStyle = css`
  border: none;
  border-radius: .5rem;
  box-shadow: 0rem -.0625rem 0rem 0rem #b5b5b5 inset, 0rem 0rem 0rem .0625rem rgba(0, 0, 0, .1) inset, 0rem .03125rem 0rem .09375rem #FFF inset;
  color: rgba(74, 74, 74, 1);
  cursor: pointer;
  user-select: none;
  touch-action: manipulation;
  background-color: #ffffff; 
`

export const buttonHoverStyle = css`
  color: rgba(48, 48, 48, 1);
  background-color: rgba(250, 250, 250, 1);
`

export const buttonActiveStyle = css`
  color: rgba(48, 48, 48, 1);
  background: rgba(247, 247, 247, 1);
  box-shadow: -.0625rem 0rem .0625rem 0rem rgba(26, 26, 26, .122) inset, .0625rem 0rem .0625rem 0rem rgba(26, 26, 26, .122) inset, 0rem .125rem .0625rem 0rem rgba(26, 26, 26, .2) inset;
`
export const buttonActiveShadowStyle = css`
  box-shadow: -.0625rem 0rem .0625rem 0rem rgba(26, 26, 26, .122) inset, .0625rem 0rem .0625rem 0rem rgba(26, 26, 26, .122) inset, 0rem .125rem .0625rem 0rem rgba(26, 26, 26, .2) inset;
`